export default {
    //两个REJECTED
    "UNPAID": "UNPAID",
    "PAID": "PAID",
    "SUBMITTED": "SUBMITTED",
    "PENDING": "PENDING",
    "VERIFIED": "VERIFIED",
    "REJECTED": "REJECTED",
    "CANCELED": "CANCELED",
    "DISABLED": "DISABLED",
    "PENDING_PAY": "PENDING_PAY",




    '基础版':'Basic Edition',
    '升级版':'Upgraded version',
    '豪华版':'Deluxe Edition',

    'EXPORTED':'EXPORTED',
    'UNEXPORTED':'UNEXPORTED',
    'APPLYED':'APPLYED',

    'REFUNDED':'REFUNDED',
    'COMPLETED':'COMPLETED',
    'FINISH':'FAILED',
    'ISSUEBILL':'ISSUEBILL',
    'POLICY_FAIL':'POLICY_FAIL',
    'SURRENDERED':'SURRENDERED',


}


// WEBPACK FOOTER //
// ./src/i18n/en-us/dataI18n/insuranceStatus.js